import {LogEvent} from '../events.js';

export class IcebreakerResponse extends LogEvent {
  /**
   * Creates an instance of IcebreakerResponse.
   * @param {string} text - The text of the icebreaker response.
   * @param {number} ibid - The identifier of the icebreaker.
   * @param {string} recipient - The recipient of the response.
   */
  constructor(text, ibid, recipient) {
    super();
    this.text = text;
    this.icebreakerId = ibid;
    this.recipient = recipient;
    this.type = 'IcebreakerResponse';
  }

  /**
   * Returns a data transfer object representing the IcebreakerResponse.
   * @returns {import('../events').LogEventDTO} The data transfer object for the icebreaker response.
   */
  getDTO() {
    const dto = super.getDTO();
    dto.itemId = `${this.icebreakerId}`;
    dto.amateurId = this.recipient;
    return dto;
  }
}
